import { SpecialOfferWindow } from '@utils/special-offer-time-utils';
import SpecialOfferCountdownTimer from '../subscribe/SpecialOfferCountdownTimer';
import { regular_sm } from '../texts/Styles';

export default function PricingBannerComponent({
  specialOfferWindow,
}: {
  specialOfferWindow?: SpecialOfferWindow;
}) {
  if (!specialOfferWindow) {
    return null;
  }

  return (
    <div
      className={`sticky top-[82px] z-50 -mt-12 w-full px-6 tablet:px-10 ${regular_sm}`}
    >
      <div className="flex h-12 items-center justify-center rounded-xl bg-product2-accent-success text-product2-content-inverse">
        <span className="hidden sm:block">🔥 Limited special offer - </span>
        <span className="sm:hidden">🔥 Now</span>
        <span className={`ml-1`}>
          {specialOfferWindow.discountPercent}% OFF
        </span>
        <SpecialOfferCountdownTimer
          className="ml-6 font-aeonikMono"
          endDate={specialOfferWindow.endDate}
        ></SpecialOfferCountdownTimer>
      </div>
    </div>
  );
}
